module.exports = __webpack_public_path__ + "img/stage-3.96b39b53.png";